export const FIELDS_MAPPING_DELETE_MODAL_WIDTH = '510px';
export const FIELDS_MAPPING_MODAL_WIDTH = '1355px';
export const FIELDS_MAPPING_POLYGON_MODAL_WIDTH = '1000px';
export const IMPORT_RULES_MODAL_WIDTH = '580px';
export const RESULT_STATISTIC_MODAL_WIDTH = '480px';
export const NEXT_DISABLED_TOOLTIP_TEXT = 'You can’t proceed as you selected to skip all the fields';
